// extracted by mini-css-extract-plugin
module.exports = {"mainText":"team_mainText__2d2_2","wrapper":"team_wrapper__jpoZT","jumbotron":"team_jumbotron__2E5Y5"};